export const getNotesApi = (params, query) => {
    const queryString = new URLSearchParams(query).toString();
    return `lease/${params?.leaseSlug}/lease-notes/${queryString ? `?${queryString}` : ""}`;
};

export const addNotesApi = (params) => {
    return `lease/${params?.leaseSlug}/lease-notes/`;
};

export const updateNotesApi = (params) => {
    return `lease/${params?.leaseSlug}/lease-notes/${params?.id}/`;
};

export const deleteNotesApi = (params) => {
    return `lease/${params?.leaseSlug}/lease-notes/`;
};